import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export function setAdminToken(token) {
  if (token) {
    localStorage.setItem("bf_admin_token", token);
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem("bf_admin_token");
    delete api.defaults.headers.common.Authorization;
  }
}

const existing = localStorage.getItem("bf_admin_token");
if (existing) {
  api.defaults.headers.common.Authorization = `Bearer ${existing}`;
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return err?.message || "Une erreur est survenue";
}

export default api;
